"use client";
import { ChevronDown as e } from "../Icon/icons.gen.mjs";
import { DEFAULT_ICON_CLASS_NAME as t } from "../../../utils/iconDefaults.mjs";
import { appendToChildren as n } from "../../../utils/appendToChildren.mjs";
import { forwardRef as r } from "react";
import { jsx as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-navigation-menu";
//#region src/components/atoms/NavigationMenu/NavigationMenu.tsx
var o = r((e, t) => /* @__PURE__ */ i(a.Root, {
	"data-slot": "navigation-menu",
	...e,
	ref: t
}));
o.displayName = "NavigationMenuRoot";
var s = r((e, t) => /* @__PURE__ */ i(a.Sub, {
	"data-slot": "navigation-menu-sub",
	...e,
	ref: t
}));
s.displayName = "NavigationMenuSub";
var c = r((e, t) => /* @__PURE__ */ i(a.List, {
	"data-slot": "navigation-menu-list",
	...e,
	ref: t
}));
c.displayName = "NavigationMenuList";
var l = r((e, t) => /* @__PURE__ */ i(a.Item, {
	"data-slot": "navigation-menu-item",
	...e,
	ref: t
}));
l.displayName = "NavigationMenuItem";
var u = r(({ children: r, icon: o = /* @__PURE__ */ i(e, {
	"data-slot": "navigation-menu-trigger-icon",
	"aria-hidden": "true",
	className: t
}), asChild: s, ...c }, l) => /* @__PURE__ */ i(a.Trigger, {
	"data-slot": "navigation-menu-trigger",
	asChild: s,
	...c,
	ref: l,
	children: n(r, o, s)
}));
u.displayName = "NavigationMenuTrigger";
var d = r((e, t) => /* @__PURE__ */ i(a.Content, {
	"data-slot": "navigation-menu-content",
	...e,
	ref: t
}));
d.displayName = "NavigationMenuContent";
var f = r((e, t) => /* @__PURE__ */ i(a.Link, {
	"data-slot": "navigation-menu-link",
	...e,
	ref: t
}));
f.displayName = "NavigationMenuLink";
var p = r((e, t) => /* @__PURE__ */ i(a.Indicator, {
	"data-slot": "navigation-menu-indicator",
	...e,
	ref: t
}));
p.displayName = "NavigationMenuIndicator";
var m = r((e, t) => /* @__PURE__ */ i(a.Viewport, {
	"data-slot": "navigation-menu-viewport",
	...e,
	ref: t
}));
m.displayName = "NavigationMenuViewport";
//#endregion
export { d as NavigationMenuContent, p as NavigationMenuIndicator, l as NavigationMenuItem, f as NavigationMenuLink, c as NavigationMenuList, o as NavigationMenuRoot, s as NavigationMenuSub, u as NavigationMenuTrigger, m as NavigationMenuViewport };
